var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-Check-In-selected-new",
    transform: "translate(-336.000000, -18.000000)",
    stroke: "#0084F8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(336.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    opacity: 0.35,
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2-Copy-3",
    strokeWidth: 2,
    points: "8 12.05 11.6976584 16.1 17 8"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Checkin.ee9b6f81.svg";
export { ForwardRef as ReactComponent };